import { SectionInfo } from '@data/course/courseData';
import React from 'react';
import MeetingDisplay from './MeetingDisplay';

interface SectionDisplayProps {
  section: SectionInfo;
  sectionNumber: number;
}

const SectionDisplay: React.FC<SectionDisplayProps> = ({ section, sectionNumber }) => {
  const meeting1 = section.meetings[0];
  const meeting2 = section.meetings[1];

  return (
    <p>
      Section {sectionNumber}: <MeetingDisplay meeting={meeting1} />
      {meeting2 ? ' and ' : ''}
      {meeting2 ? <MeetingDisplay meeting={meeting2} /> : null}
    </p>
  );
};

export default SectionDisplay;
